<nav class="navbar sticky-top navbar-expand-lg bg-primary p-0">
  <div class="container-fluid">
    <div class="navbar-brand fade-in-sm" [class.fade-in]="!isHome()" #navbarLogo>
      <a [routerLink]="['/']" class="navbar-logo-text">
        <img ngSrc="https://cdn.sersoft.de/img/sersoft/logo_horizontal_noslogan_white.svg"
             width="495" height="163" class="w-auto ps-3" style="height: 40px;" alt="ser.soft Logo" i18n-alt/>
      </a>
    </div>

    <button class="navbar-toggler"
            type="button"
            data-bs-theme="dark"
            data-bs-toggle="collapse"
            data-bs-target="#navbarToggler"
            aria-controls="navbarToggler"
            aria-expanded="true"
            aria-label="Navigation umschalten"
            i18n-aria-label>
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar-collapse collapse" id="navbarToggler">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        @for (item of items; track item.routerLink) {
          <li class="nav-item">
            <a class="nav-link p-3"
               aria-current="page"
               [routerLink]="item.routerLink"
               [routerLinkActive]="['active']"
               [routerLinkActiveOptions]="{exact: true}">
              {{ item.label }}
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</nav>
